/**
 * Swym Wishlist Plus — wishlist / shared wishlist page renderer
 * Supports:
 * - Personal wishlist (swat.fetch / fetchLists)
 * - Shared wishlist links (?hkey=…&lid=…) via fetchListDetails
 * - Add to cart, remove (owner only), empty + error states
 */
(function () {
  'use strict';

  var productCardMarkup =
    '<div class="swym-wishlist-grid">' +
    '{{#products}}' +
    '<a href="{{du}}" aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">' +
    '{{^isShared}}' +
    '<button type="button" id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-product-url="{{du}}" data-list-id="{{lid}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>' +
    '{{/isShared}}' +
    '<div class="swym-wishlist-image-wrapper"><img alt="{{dt}}" class="swym-wishlist-image" src="{{iu}}"></div>' +
    '<button type="button" class="swym-is-button"><div class="swym-title swym-title-1">{{dt}}</div></button>' +
    '<div class="swym-letiant-title swym-text swym-title-2 swym-letiant-title-spacer">{{letiantinfo}}</div>' +
    '<div class="swym-product-price swym-text swym-text-1">' +
    '<div class="swym-product-final-price swym-value">{{cu}}{{pr}}</div>' +
    '</div>' +
    '<button type="button" id="swym-custom-add-toCartBtn" class="btn product-form__cart-submit swym-add-to-cart-btn swym-button swym-button-1 swym-is-button" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}">' +
    '{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}' +
    '</button>' +
    '</a>' +
    '{{/products}}' +
    '</div>';

  var state = {
    isShared: false,
    sharedLid: null
  };

  function getQueryParams(swat) {
    if (swat && swat.utils && typeof swat.utils.getEncodedAsObject === 'function') {
      return swat.utils.getEncodedAsObject(window.location.search) || {};
    }

    var params = {};
    var search = window.location.search || '';
    if (!search) return params;

    search
      .replace(/^\?/, '')
      .split('&')
      .forEach(function (pair) {
        if (!pair) return;
        var parts = pair.split('=');
        var key = decodeURIComponent(parts[0] || '');
        var value = decodeURIComponent((parts[1] || '').replace(/\+/g, ' '));
        if (key) params[key] = value;
      });

    return params;
  }

  function getSectionRoot() {
    return document.querySelector('[data-swym-wishlist-section]') || document.getElementById('swym-wishlist-page');
  }

  function getContainer() {
    return document.getElementById('wishlist-items-container');
  }

  function getCopy(key, fallback) {
    var container = getContainer();
    if (!container) return fallback;
    return container.getAttribute('data-swym-' + key) || fallback;
  }

  function setBusy(isBusy) {
    var container = getContainer();
    if (container) {
      container.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }
  }

  function showState(type, message) {
    var container = getContainer();
    if (!container) return;

    var className = 'swym-wishlist-page__state';
    if (type === 'error') className += ' swym-wishlist-page__state--error';
    if (type === 'empty') className += ' swym-wishlist-page__state--empty';
    if (type === 'loading') className += ' swym-wishlist-page__state--loading';

    container.innerHTML =
      '<div class="' + className + '"><p>' + (message || '') + '</p></div>';
    setBusy(type === 'loading');
  }

  function getVariantInfo(variants) {
    try {
      var variantKeys =
        variants && variants !== '[]' ? Object.keys(JSON.parse(variants)[0]) : [];
      if (variantKeys.length > 0) {
        return variantKeys[0] === 'Default Title' ? '' : variantKeys[0];
      }
      return '';
    } catch (err) {
      return variants || '';
    }
  }

  function formatProducts(products, swat) {
    return (products || []).map(function (p) {
      p = SwymUtils.formatProductPrice(p);
      p.isInCart =
        swat.platform.isInDeviceCart(p.epi) || p.et == swat.EventTypes.addToCart;
      p.letiantinfo = p.vi ? getVariantInfo(p.vi) : '';
      p.isShared = state.isShared;
      p.lid = p.lid || state.sharedLid || '';
      return p;
    });
  }

  function renderProductGrid(products, swat) {
    var container = getContainer();
    if (!container) {
      console.warn('Swym wishlist: #wishlist-items-container not found');
      return;
    }

    if (!products || products.length === 0) {
      showState('empty', getCopy('empty-text', 'This wishlist is empty.'));
      return;
    }

    var formatted = formatProducts(products, swat);
    var markup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formatted
    });

    container.innerHTML = markup;
    setBusy(false);
    attachClickListeners();
  }

  function detectSharedMode(swat) {
    var params = getQueryParams(swat);
    var hkey = params.hkey || params.HKEY || '';
    var lid = params.lid || params.LID || '';
    var sharedKey = hkey || lid;
    var section = getSectionRoot();
    var mode = section ? section.getAttribute('data-wishlist-mode') : 'auto';

    if (mode === 'shared' || sharedKey) {
      state.isShared = true;
      state.sharedLid = lid || hkey || null;
      if (section) section.classList.add('is-shared');
      return sharedKey;
    }

    state.isShared = false;
    state.sharedLid = null;
    if (section) section.classList.remove('is-shared');
    return null;
  }

  function fetchSharedWishlist(swat, sharedKey) {
    showState('loading', getCopy('loading-text', 'Loading wishlist…'));

    var onSuccess = function (listDetails) {
      var items =
        (listDetails && (listDetails.items || listDetails.listcontents)) || [];
      if (listDetails && listDetails.lid) {
        state.sharedLid = listDetails.lid;
      }
      renderProductGrid(items, swat);
    };

    var onError = function (err) {
      console.error('Swym wishlist: failed to load shared list', err);

      // Official Swym shared UI fallback (handles hkey when custom fetch fails)
      if (
        swat.ui &&
        typeof swat.ui.renderSharedWishlistInContainer === 'function'
      ) {
        var container = getContainer();
        var params = getQueryParams(swat);
        if (container) {
          container.innerHTML = '';
          try {
            swat.ui.renderSharedWishlistInContainer(container, sharedKey, params);
            setBusy(false);
            return;
          } catch (renderErr) {
            console.error('Swym wishlist: shared UI render failed', renderErr);
          }
        }
      }

      showState(
        'error',
        getCopy(
          'error-text',
          'Unable to load this wishlist. The link may be invalid or expired.'
        )
      );
    };

    if (typeof swat.fetchListDetails === 'function') {
      swat.fetchListDetails({ lid: sharedKey }, onSuccess, onError);
      return;
    }

    onError(new Error('fetchListDetails unavailable'));
  }

  function fetchPersonalWishlist(swat) {
    showState('loading', getCopy('loading-text', 'Loading wishlist…'));

    swat.fetch(function (products) {
      renderProductGrid(products, swat);
    }, function (err) {
      console.error('Swym wishlist: failed to load personal wishlist', err);
      showState(
        'error',
        getCopy('error-text', 'Unable to load this wishlist. Please try again.')
      );
    });
  }

  window.swymRenderWishlist = function swymRenderWishlist(swat) {
    if (!getContainer()) {
      console.warn('Swym wishlist: container missing, skip render');
      return;
    }

    var sharedKey = detectSharedMode(swat);
    if (sharedKey) {
      fetchSharedWishlist(swat, sharedKey);
    } else {
      fetchPersonalWishlist(swat);
    }
  };

  function openSidebarCart() {
    var settings = window.themeVariables && window.themeVariables.settings;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    if (settings && (settings.cartType === 'page' || settings.pageType === 'cart')) {
      window.location.href = root + 'cart';
      return;
    }

    var cartDrawer = document.querySelector('cart-drawer');
    var opened = false;

    function showDrawer() {
      if (opened) return;
      opened = true;

      if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
        return;
      }

      var openTrigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (openTrigger) openTrigger.click();
    }

    // Prestige refreshes drawer HTML on cart:refresh, then we open <cart-drawer>.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    if (cartDrawer) {
      cartDrawer.addEventListener('cart-drawer:refreshed', showDrawer, { once: true });
      setTimeout(showDrawer, 800);
    } else {
      showDrawer();
    }
  }

  function onAddToCartClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var button = e.currentTarget;
    var productId = button.getAttribute('data-product-id');
    var variantId = button.getAttribute('data-variant-id') || button.getAttribute('data-letiant-id');
    var productUrl = button.getAttribute('data-product-url');

    button.innerHTML = 'Adding..';
    button.disabled = true;

    window._swat.replayAddToCart(
      { empi: productId, du: productUrl },
      variantId,
      function () {
        button.innerHTML = 'Added to Cart';
        button.setAttribute('data-state-cart', 'swym-added');
        button.disabled = false;
        openSidebarCart();
      },
      function (err) {
        console.error('Swym wishlist: add to cart failed', err);
        button.innerHTML = 'Product not available';
        button.disabled = false;
      }
    );
  }

  function onRemoveBtnClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (state.isShared) return;

    var button = e.currentTarget;
    var epi = Number(button.getAttribute('data-variant-id') || button.getAttribute('data-letiant-id'));
    var empi = Number(button.getAttribute('data-product-id'));
    var listId = button.getAttribute('data-list-id');
    var wishlistItem = button.closest('.swym-wishlist-item');
    var du =
      button.getAttribute('data-product-url') ||
      (wishlistItem && wishlistItem.getAttribute('href')) ||
      '';

    button.disabled = true;

    if (wishlistItem) {
      wishlistItem.style.position = 'relative';
      var overlay = document.createElement('div');
      overlay.className = 'swym-wishlist-removing-overlay';
      overlay.style.cssText =
        'position:absolute;inset:0;background:rgba(255,255,255,0.8);display:flex;align-items:center;justify-content:center;z-index:2;';
      overlay.innerHTML = '<div>Removing…</div>';
      wishlistItem.appendChild(overlay);
    }

    var productObject = { empi: empi, epi: epi, du: du };

    function finishRemove() {
      if (window._swat) {
        window.swymRenderWishlist(window._swat);
      }
    }

    function failRemove(err) {
      console.error('Swym wishlist: remove failed', err);
      button.disabled = false;
      if (wishlistItem) {
        var existing = wishlistItem.querySelector('.swym-wishlist-removing-overlay');
        if (existing) existing.remove();
      }
    }

    if (listId && du && typeof window._swat.deleteFromList === 'function') {
      window._swat.deleteFromList(listId, productObject, finishRemove, failRemove);
      return;
    }

    window._swat.fetch(function (products) {
      var match = (products || []).find(function (product) {
        return product.epi == epi && product.empi == empi;
      });

      if (!match) {
        failRemove(new Error('Product not found in wishlist'));
        return;
      }

      productObject.du = match.du;
      window._swat.deleteFromList(match.lid, productObject, finishRemove, failRemove);
    }, failRemove);
  }

  function attachClickListeners() {
    document.querySelectorAll('#swym-custom-add-toCartBtn').forEach(function (btn) {
      btn.removeEventListener('click', onAddToCartClick);
      btn.addEventListener('click', onAddToCartClick, false);
    });

    document.querySelectorAll('#swym-remove-productBtn').forEach(function (btn) {
      btn.removeEventListener('click', onRemoveBtnClick);
      btn.addEventListener('click', onRemoveBtnClick, false);
    });
  }

  /* --------- List filter support (used by templates/page.wishlist.liquid) --------- */

  var fetchWishlistCallbackFn = function (listDetails) {
    var container = getContainer();
    if (!container) return;

    if (!listDetails || !listDetails.items || listDetails.items.length === 0) {
      showState('empty', getCopy('empty-text', 'No items in this wishlist'));
      return;
    }

    if (!window._swat) return;
    state.isShared = false;
    state.sharedLid = listDetails.lid || null;
    renderProductGrid(listDetails.items, window._swat);
  };

  var fetchWishlistErrorFn = function (err) {
    console.error('Swym wishlist: fetchListDetails error', err);
    showState(
      'error',
      getCopy('error-text', 'Error loading wishlist items')
    );

    if (typeof Toastify === 'function') {
      Toastify({
        text: 'Error loading wishlist items',
        style: { background: '#000' },
        duration: 3000
      }).showToast();
    }
  };

  var filterWishlist = document.getElementById('filter-wishlist');
  if (filterWishlist) {
    filterWishlist.addEventListener('change', function () {
      var selectedListId = this.value;
      var container = getContainer();
      if (!container || !window._swat) return;

      if (selectedListId === 'none') {
        if (!window.SwymCallbacks) window.SwymCallbacks = [];
        window.SwymCallbacks.push(window.swymRenderWishlist);
        window.swymRenderWishlist(window._swat);
        return;
      }

      showState('loading', 'Loading wishlist items...');
      window._swat.fetchListDetails(
        { lid: selectedListId },
        fetchWishlistCallbackFn,
        fetchWishlistErrorFn
      );
    });
  }

  /* --------- Boot --------- */

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(window.swymRenderWishlist);
})();
